import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=6f9a789f&"
import script from "./Tel.vue?vue&type=script&lang=js&"
export * from "./Tel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports